import { Injectable } from '@angular/core';
import { Observable }from 'rxjs';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import * as globals from './globals';


@Injectable()
export class LoginService{
  urlLogin:string = globals.URL+"/backend/login.php"
  urlLogout:string = globals.URL+"/backend/logout.php"
  logged:boolean = false
  constructor(private http: HttpClient) {
  	this.http.get(this.urlLogin).subscribe((data:any) => {this.logged = data.status == "already logged"? true : false;console.log(data);console.log(this.logged);})
  }
 
  login(username:string, password:string){
  	let formData:FormData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    
  	//return this.http.post(this.urlLogin, {'username':username, 'password':password})
  	this.http.post(this.urlLogin, formData).subscribe((data:any) => {this.logged = data.status == "ok"? true : false;console.log(data);})
  }
  logout(){
    this.http.post(this.urlLogout, {}).subscribe((data:any) => {this.logged = data.logout == "ok"? false : true;console.log(data)})
  }
}



// WEBPACK FOOTER //
// ./src/app/login.service.ts